'use client';

import { ChevronIcon } from '@/components/ui';
import { UniversalLink } from '../UniversalLink';
import { Entry } from 'contentful';
import { UniversalLinkFields } from '../UniversalLink';
import * as Contentful from 'contentful';
import { useState } from 'react';
import {
  trackItemClickedEvent,
  CLICKED_ITEM_TYPES,
  PAGE_LOCATIONS,
  CTA_NAMES,
} from '@/utils/rudderstack';

export interface NavMenuItemDropdownProps {
  menuItem: Entry<UniversalLinkFields>;
  playKitsByAgeLinks?: Contentful.Entry<Record<string, any>>[];
  playKitsDropdownLinks?: Contentful.Entry<Record<string, any>>[];
}

export const NavMenuItemDropdown = ({
  menuItem,
  playKitsByAgeLinks,
  playKitsDropdownLinks,
}: NavMenuItemDropdownProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleLinkClick = (linkText: string) => {
    trackItemClickedEvent({
      type: CLICKED_ITEM_TYPES.LINK,
      cta: linkText as CTA_NAMES,
      pageLocation: PAGE_LOCATIONS.NAVIGATION,
      url: window.location.href,
    });
  };

  return (
    <div className="dropdown dropdown-hover">
      <label
        tabIndex={0}
        className="mr-6 flex w-max flex-row items-center font-bold hover:text-blue-deep xl:mr-9"
        onMouseEnter={() => setIsExpanded(true)}
      >
        {menuItem.fields.linkText}
        <ChevronIcon
          direction="down"
          classes="w-4 h-4 ml-2 hover:text-blue-deep"
        />
      </label>
      {isExpanded && (
        <div className="dropdown-content menu w-max bg-white font-normal shadow-lg p-6">
          <h4 className="text-xl mb-2 font-bold">Shop by age:</h4>
          <ul key={menuItem.sys.id} tabIndex={0}>
            {playKitsByAgeLinks &&
              playKitsByAgeLinks?.length > 0 &&
              playKitsByAgeLinks.map((link: any) => {
                return (
                  <li
                    key={link.sys.id}
                    onClick={() => setIsExpanded(!isExpanded)}
                  >
                    <UniversalLink
                      link={link}
                      classes="hover:text-blue-deep font-medium mt-3"
                      onClick={() => handleLinkClick(link.fields.linkText)}
                    />
                  </li>
                );
              })}
          </ul>
          <div className="border-t border-gray-200 my-4"></div>
          <ul key={menuItem.sys.id} tabIndex={0}>
            {playKitsDropdownLinks &&
              playKitsDropdownLinks?.length > 0 &&
              playKitsDropdownLinks.map((link: any) => {
                return (
                  <li
                    key={link.sys.id}
                    onClick={() => setIsExpanded(!isExpanded)}
                  >
                    <UniversalLink
                      link={link}
                      classes="hover:text-blue-deep font-medium mt-3"
                      onClick={() => handleLinkClick(link.fields.linkText)}
                    />
                  </li>
                );
              })}
          </ul>
        </div>
      )}
    </div>
  );
};
